@if (dateFormatForm) {
  <div class="form-container" [formGroup]="dateFormatForm">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <div class="control-div">
          <div class="control-label-container">
            <label class="control-label"> Name </label>
          </div>
          <clickatell-form-validation [controlName]="'name'"
          [form]="dateFormatForm"></clickatell-form-validation>
          <input class="control-input" activeForm [activeForm]="dateFormatForm" id="name"
            [formControlName]="'name'" placeholder="Enter name"/>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Description </label>
            </div>
            <clickatell-form-validation [controlName]="'description'"
            [form]="dateFormatForm"></clickatell-form-validation>
            <input class="control-input" activeForm [activeForm]="dateFormatForm" id="description"
              [formControlName]="'description'" placeholder="Enter description"/>
            </div>
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Variable Name </label>
              </div>
              <clickatell-form-validation [controlName]="'variableName'"
              [form]="dateFormatForm"></clickatell-form-validation>
              <input class="control-input" activeForm [activeForm]="dateFormatForm" id="variableName"
                [formControlName]="'variableName'" placeholder="Enter variable name"/>
              </div>
              <div class="control-div">
                <div class="control-label-container">
                  <label class="control-label"> Pattern From </label>
                </div>
                <clickatell-form-validation [controlName]="'patternFrom'"
                [form]="dateFormatForm"></clickatell-form-validation>
                <input class="control-input" activeForm [activeForm]="dateFormatForm" id="patternFrom"
                  [formControlName]="'patternFrom'" placeholder="Enter pattern from"/>
                </div>
                <div class="control-div">
                  <div class="control-label-container">
                    <label class="control-label"> Pattern To </label>
                  </div>
                  <clickatell-form-validation [controlName]="'patternTo'"
                  [form]="dateFormatForm"></clickatell-form-validation>
                  <input class="control-input" activeForm [activeForm]="dateFormatForm" id="patternTo"
                    [formControlName]="'patternTo'" placeholder="Enter pattern to"/>
                  </div>
                </ng-container>
              </clickatell-expansion-panel>
              <clickatell-expansion-panel>
                <ng-container header>
                  <mat-panel-title>
                    Logic
                  </mat-panel-title>
                </ng-container>
                <ng-container body>
                  <div class="control-result">
                    <div class="control-result-header">
                      Yes
                    </div>
                    <div class="control-result-container">
                      <div class="control-div">
                        <label class="control-label">
                          <span class="pont-to">Point To</span>
                          <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                        </label>
                        @if (nodeFlowDetails) {
                          <next-selector [canEditFlows]="canEdit.canEditFlows"
                            [selectorType]="'both'"
                            [flowSteps]="nodeFlowDetails.currentFlowSteps"
                            [flows]="nodeFlowDetails.flows"
                            [name]="'yes'"
                            [form]="dateFormatForm"
                            [stepId]="nodeFlowDetails.stepId">
                          </next-selector>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="control-result">
                    <div class="control-result-header">
                      No
                    </div>
                    <div class="control-result-container">
                      <div class="control-div">
                        <label class="control-label">
                          <span class="pont-to">Point To</span>
                          <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                        </label>
                        @if (nodeFlowDetails) {
                          <next-selector [canEditFlows]="canEdit.canEditFlows"
                            [selectorType]="'both'"
                            [flowSteps]="nodeFlowDetails.currentFlowSteps"
                            [flows]="nodeFlowDetails.flows"
                            [name]="'no'"
                            [form]="dateFormatForm"
                            [stepId]="nodeFlowDetails.stepId">
                          </next-selector>
                        }
                      </div>
                    </div>
                  </div>
                </ng-container>
              </clickatell-expansion-panel>
            </div>
          }